/**
 * Note Reducers for AccountSlice
 * 
 * Handles account notes management.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { AccountSliceState } from '../state';
import { AccountNoteView } from '../../types/accountTypes';

/**
 * Add a note to the account
 */
export const addNote: CaseReducer<
  AccountSliceState,
  PayloadAction<AccountNoteView>
> = (state, action) => {
  if (state.currentAccount) {
    state.currentAccount.notes = [
      ...state.currentAccount.notes,
      action.payload,
    ];
    state.isEdited = true;
  }
};

/**
 * Update a note on the account
 */
export const updateNote: CaseReducer<
  AccountSliceState,
  PayloadAction<{ id: string; updates: Partial<AccountNoteView> }>
> = (state, action) => {
  if (state.currentAccount) {
    const noteIndex = state.currentAccount.notes.findIndex(
      (n) => n.id === action.payload.id
    );
    if (noteIndex !== -1) {
      state.currentAccount.notes[noteIndex] = {
        ...state.currentAccount.notes[noteIndex],
        ...action.payload.updates,
      };
      state.isEdited = true;
    }
  }
};

/**
 * Remove a note from the account
 */
export const removeNote: CaseReducer<
  AccountSliceState,
  PayloadAction<string>
> = (state, action) => {
  if (state.currentAccount) {
    state.currentAccount.notes = state.currentAccount.notes.filter(
      (n) => n.id !== action.payload
    );
    state.isEdited = true;
  }
};
